const DEFAULT_NORMAL_SETTLEMENT_ITEM = '正常结算'
const DEFAULT_PART_SETTLEMENT_ITEM = '正常部分结算'
const DEFAULT_ABNORMAL_SETTLEMENT_ITEM = '异常结算'

function toNumber (value) {
  const numberValue = Number(value)
  return Number.isFinite(numberValue) ? numberValue : 0
}

function toStringValue (value) {
  if (value === null || value === undefined) return ''
  return String(value)
}

function formatNumber (value) {
  const numberValue = toNumber(value)
  if (Number.isInteger(numberValue)) return String(numberValue)
  return String(Number(numberValue.toFixed(2)))
}

function cloneFiles (files) {
  return Array.isArray(files) ? files.map(item => ({...item})) : []
}

export function recalculateSettlementRow (row) {
  const unitPrice = toNumber(row.unit_price)
  const storeCount = toNumber(row.store_count)
  return {
    settlement_item: toStringValue(row.settlement_item),
    unit_price: toStringValue(row.unit_price),
    store_count: toStringValue(row.store_count),
    subtotal: formatNumber(unitPrice * storeCount),
  }
}

export function createSettlementRow (item = '', unitPrice = '', storeCount = '') {
  return recalculateSettlementRow({
    settlement_item: item,
    unit_price: toStringValue(unitPrice),
    store_count: toStringValue(storeCount),
    subtotal: '0',
  })
}

function hydrateList (list) {
  if (!Array.isArray(list)) return null
  return list.map(row => recalculateSettlementRow(row))
}

function hasValue (value) {
  return value !== null && value !== undefined && value !== ''
}

export function hydrateProjectReportForm (nodeResult = {}) {
  const normalList = hydrateList(nodeResult.normal_settled_list)
  const abnormalList = hydrateList(nodeResult.abnormal_voided_list)
  return {
    version: Number(nodeResult.version) || 1,
    full_settlement: toStringValue(nodeResult.full_settlement),
    part_settlement: toStringValue(nodeResult.part_settlement),
    invalid_data: toStringValue(nodeResult.invalid_data),
    project_report_files: cloneFiles(nodeResult.project_report_files),
    file_remarks: toStringValue(nodeResult.file_remarks),
    normal_settled_list: normalList || [
      ...(hasValue(nodeResult.full_settlement)
        ? [createSettlementRow(DEFAULT_NORMAL_SETTLEMENT_ITEM, 0, nodeResult.full_settlement)]
        : []),
      ...(hasValue(nodeResult.part_settlement)
        ? [createSettlementRow(DEFAULT_PART_SETTLEMENT_ITEM, 0, nodeResult.part_settlement)]
        : []),
    ],
    abnormal_voided_list: abnormalList || (
      hasValue(nodeResult.invalid_data)
        ? [createSettlementRow(DEFAULT_ABNORMAL_SETTLEMENT_ITEM, 0, nodeResult.invalid_data)]
        : []
    ),
  }
}

function normalizeList (list) {
  return (list || []).map(row => recalculateSettlementRow(row))
}

function sumStoreCount (list) {
  return list.reduce((sum, row) => sum + toNumber(row.store_count), 0)
}

function getStoreCountByItem (list, settlementItem) {
  return list.reduce((sum, row) => {
    return row.settlement_item === settlementItem ? sum + toNumber(row.store_count) : sum
  }, 0)
}

export function sumSettlementSubtotal (...lists) {
  return lists.reduce((sum, list) => {
    return sum + normalizeList(list).reduce((listSum, row) => listSum + toNumber(row.subtotal), 0)
  }, 0)
}

export function buildProjectReportSubmitParams (projectId, form) {
  const normalList = normalizeList(form.normal_settled_list)
  const abnormalList = normalizeList(form.abnormal_voided_list)
  return {
    id: projectId,
    ...form,
    version: Number(form.version) || 1,
    normal_settled_list: normalList,
    abnormal_voided_list: abnormalList,
    full_settlement: formatNumber(getStoreCountByItem(normalList, DEFAULT_NORMAL_SETTLEMENT_ITEM)),
    part_settlement: formatNumber(getStoreCountByItem(normalList, DEFAULT_PART_SETTLEMENT_ITEM)),
    invalid_data: formatNumber(sumStoreCount(abnormalList)),
  }
}



// WEBPACK FOOTER //
// ./src/views/project/project-report-settlement.js